<template>
  <div class="content-wrapper">
    <!-- 关键修改：v-for 必须绑定唯一 ID，严禁使用 index -->
    <div class="box" v-for="(item, index) in list"
      :key="item.iccid + '-' + (item.recharge_id || item.addflow_id || index)">
      <div class="title" @dblclick="formatCopy(item.iccid)">
        <div class="methodTitle">
          <h3 class="label">ICCID:</h3>
          <h3 class="value">{{ formatICCID(item.iccid) }}</h3>
        </div>
        <div class="methodTitle">
          <h3 class="label">订单编号:</h3>
          <h3 class="value">{{ item.recharge_id }}</h3>
        </div>
        <div class="methodTitle">
          <h3 class="label">时间:</h3>
          <h3 class="value" >{{ item.recharge_date }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li>
              <h3>套餐名称</h3>
              <p>{{ item.pk_name }}</p>
            </li>
            <li>
              <h3>流量</h3>
              <p>{{ item.flow }}MB</p>
            </li>
            <li>
              <h3>售价</h3>
              <p>{{ item.recharge_amount>0?item.recharge_amount +'元':'-'}}</p>
            </li>
            <li>
              <h3>分润</h3>
              <p>{{ item.profit_amount>0?item.profit_amount +'元':'-'}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="zwf"></div>
  </div>
</template>

<script>
import { copyText } from '@/utils/copy.js'
export default {
  name: 'OrderVanCollapseContent',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatICCID (iccid) {
      if (!iccid) return ''
      const str = String(iccid)
      // 4位一分隔
      return str.match(/.{1,4}/g).join(' ')
    },
    formatCopy (iccid) {
      copyText(iccid)
    }
  }
}
</script>

<style scoped lang="less">
  [class*='van-hairline']::after {
    border: none;
  }

  .box {
    width: 690px;
    /* 注意：如果是移动端适配，建议用百分比或 rem/vw */
    max-width: 100%;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 0.08);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      flex: 2;
      width: 100%;
      /* 确保内容撑开 */

      .methodTitle {
        display: flex;
        justify-content: space-between;
        padding: 30px 0 0 40px;

        h3 {
          font-size: 30px;
          color: #838383;
          line-height: 20px;
          font-weight: 400;
        }

        .label {
          flex: 1;
          width: 150px;
        }

        .value {
          flex: 2;
        }
      }

      .methodSlidebt {
        padding: 30px 40px 0;

        ul {
          display: flex;
          justify-content: space-between;
          height: 120px;

          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;

            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9d9da3;
            }

            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
  }

  /* 装饰角标 */
  .box:after {
    display: block;
    content: '';
    width: 32px;
    height: 32px;
    // background: url(../assets/yans-3.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .zwf {
    height: 15px;
  }
</style>
